import { render } from "./EscritorioAvisosVisitasConfirmar.vue?vue&type=template&id=6d64f4cd"
import script from "./EscritorioAvisosVisitasConfirmar.vue?vue&type=script&lang=js"
export * from "./EscritorioAvisosVisitasConfirmar.vue?vue&type=script&lang=js"

import "./EscritorioAvisosVisitasConfirmar.vue?vue&type=style&index=0&id=6d64f4cd&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__